import * as React from 'react';
export const IcElderly = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10 6c.83 0 1.5-.67 1.5-1.5S10.83 3 10 3s-1.5.67-1.5 1.5S9.17 6 10 6zm5.99 6.98c0-.14-.03-.29-.1-.43l-3-6s-.06-.07-.09-.11c-.04-.06-.08-.12-.14-.17-.05-.04-.1-.07-.15-.1-.06-.04-.11-.07-.17-.1-.06-.02-.13-.03-.2-.04-.05 0-.1-.03-.15-.03h-.03c-.06 0-.12.02-.19.04s-.14.02-.2.05h-.03c-.04.02-.07.06-.11.09-.06.04-.12.08-.17.13-.04.05-.07.1-.11.16-.03.05-.07.1-.09.17-.03.07-.03.14-.04.21 0 .05-.03.09-.03.14v3.46l-2.55 1.7c-.46.31-.58.93-.28 1.39.09.13.2.23.33.31v7.64c0 .28.22.5.5.5s.5-.22.5-.5v-7.64s.04-.01.05-.03l3-2s.04-.05.07-.07c.05-.04.1-.09.14-.15.04-.05.07-.1.1-.15.03-.06.05-.11.07-.17.01-.03.03-.06.04-.1l1.02 2.04v7.9c0 .48.45.86 1 .86s1-.39 1-.86V13v-.03l.01.01z'
      fill='currentColor'
    />
  </svg>
);
